import phoneModelValidator from './phone';

export default phoneModelValidator;
